@if(tableRowsDeleteModal) {
    <app-modal *ngIf="tableRowsDeleteModal" [modalInput]="tableRowsDeleteModal" (modalCloseOutput)="handleModalClose($event)" class="table-rows-delete" testIdContext="TableRowsDelete">
        <form class="modal-content flexGrow1" [formGroup]="form">

            <div class="body-content">
                <p class="confirmation-body-text" [attr.data-testid]="'TableRowsDelete-BodyText'">{{ (bodyKey ?? 'table.delete-confirmation.body') | translate:tableRowsDeleteModal.params }}</p>
                <p class="confirmation-instructions-text" [attr.data-testid]="'TableRowsDelete-InstructionsText'">{{ 'table.delete-confirmation.instructions' | translate:tableRowsDeleteModal.params }}</p>
                <div class="count-input">
                    <app-input
                        errorClass="block"
                        width="100px"
                        formControlName="count"
                        type="number"
                    />
                </div>
            </div>

            <div class="actions">
                <app-form-buttons
                    [submitDisabled]="form.invalid"
                    (submitOutput)="submit()"
                    (cancelOutput)="cancel()"
                    submitTextKey="generics.delete"
                    testIdContext="TableRowsDelete"
                ></app-form-buttons>
            </div>
        </form>
    </app-modal>
}
